<div class="settings-select-container">
  <div class="select-left-side" style="flex-direction: column">
    <div class="select-left-item">{{ 'Automatic_withdraw' | t }}</div>
    <div class="select-left-item" style="margin-top: 5px" *ngIf="this._UiHelper.userProfileList?.IsAutoWithdraw && this._UiHelper.userProfileList?.AutoWithdrawLimit !== 0">
      Activate Date:{{ this._UiHelper.userProfileList?.AutoWithdrawDate | dateFormat : 'dd.MM.yyyy HH:mm' }} | {{ 'Amount' | t }} :
      {{ this._UiHelper.userProfileList.AutoWithdrawLimit }} {{ this._UiHelper.userProfileList.Sybol }}
    </div>
  </div>
  <div class="select-right-side">
    <div class="select-row">
      <div class="select-input">
        <mat-slide-toggle color="primary" (toggleChange)="toggleAutoWithdraw()" [checked]="this.autoWithdrawState"></mat-slide-toggle>
      </div>
    </div>
  </div>
</div>
<div class="withdraw-auto-general-container" *ngIf="this.autoWithdrawState && step === 1">
  <div class="headerDecs">
    <h2>{{ 'Automatic_Payout' | t }}</h2>
  </div>
  <div class="line"></div>

  <div class="sub-header">
    {{ 'Automatic_withdraw_Text_1' | t }}
  </div>
  <div>
    {{ 'Automatic_withdraw_Text_2' | t }}
  </div>

  <div class="rule-container">
    <div class="rule-item">{{ 'Automatic_withdraw_Text_3' | t }}</div>
    <div class="rule-item">{{ 'Automatic_withdraw_Text_4' | t }}</div>
    <ng-container [ngSwitch]="['wettarena'] | getProductName">
      <div *ngSwitchCase="'wettarena'" class="rule-item">{{ 'Automatic_withdraw_Text_5_wa' | t }}</div>
      <ng-container *ngSwitchDefault>
        <div class="rule-item">{{ 'Automatic_withdraw_Text_5_b3000' | t }}</div>
      </ng-container>
    </ng-container>
    <div class="rule-item">{{ 'Automatic_withdraw_Text_6' | t }}</div>
    <div class="rule-item">{{ 'Automatic_withdraw_Text_7' | t }}</div>
    <div class="rule-item">{{ 'Automatic_withdraw_Text_8' | t }}</div>
  </div>
  <div class="button-container-row">
    <button class="cancel-button" mat-stroked-button (click)="confirm_Contract(0)">
      {{ 'b3000_cancel' | t }}
    </button>
    <button (click)="confirm_Contract(1)" class="ok-button" mat-stroked-button>
      {{ 'pay3000_text5' | t }}
    </button>
  </div>
</div>
<div class="set-withdraw-limit-container" *ngIf="step === 2">
  <div class="headerDecs">
    <h2>{{ 'Automatic_Payout' | t }}</h2>
  </div>
  <div class="line"></div>
  <div class="info-container">
    {{ 'Automatic_withdraw_Text_9' | t }}
  </div>
  <div class="limit-input-row" style="display: flex; flex-direction: column; width: 75%">
    <div class="limit-input-container">
      <div class="input-area">
        <inputb3 [(ngModel)]="autoLimitModel" extraClass="limitInputs" fErrorText="{{ 'Required' | t }}" fSuffixText="EUR" fInputType="number"></inputb3>
      </div>
    </div>
    <div class="minAmount-description">{{ 'Mindestbetrag' | t }} {{ this._UiHelper.userProfileList.AutoWithdrawMinLimit | balanceFormat }}</div>
  </div>
  <div class="button-container-row">
    <button class="cancel-button" mat-stroked-button (click)="auto_Withdraw_Req(0)">
      {{ 'b3000_cancel' | t }}
    </button>
    <button *ngIf="autoLimitModel >= this._UiHelper.userProfileList.AutoWithdrawMinLimit; else noLimit" (click)="auto_Withdraw_Req(1)" class="ok-button" mat-stroked-button>
      {{ 'pay3000_text5' | t }}
    </button>
    <ng-template #noLimit>
      <button class="ok-button" style="opacity: 0.5" mat-stroked-button>
        {{ 'pay3000_text5' | t }}
      </button></ng-template
    >
  </div>
</div>
<div *ngIf="step === 3 && this.autoWithdrawState">
  <div style="width: 100%; text-align: center; display: flex; justify-content: center; padding: 20px; margin-bottom: 30px">
    <div style="width: 100%">
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512; padding-bottom: 20px; width: 75px"
        xml:space="preserve">
        <ellipse style="fill: #32bea6" cx="256" cy="256" rx="256" ry="255.832" />

        <polygon
          style="fill: #ffffff"
          points="235.472,392.08 114.432,297.784 148.848,253.616 223.176,311.52 345.848,134.504
391.88,166.392 " />

        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
      <!-- <h2>{{ 'Payment_Successful_Desc' | t}}</h2> -->
      <p style="display: flex; font-size: 15px; font-weight: 600; justify-content: center">
        {{ 'Automatic_withdraw_Text_10' | t }} {{ this._UiHelper.userProfileList.AutoWithdrawLimit }} {{ this._UiHelper.userProfileList.Sybol }}
        {{ 'Automatic_withdraw_Text_11' | t }}
      </p>
    </div>
  </div>
</div>
